;(function ($, window) {
  'use strict'

  window.eah = window.eah || {}

  eah.tweetShare = (function () {
    const initialize = function () {
      const url = window.location
      $('#tweetShare').on('click', function (e) {
        e.preventDefault()

        window.open('https://twitter.com/share?url=' + encodeURIComponent(url))
      })
    }

    return {
      initialize: initialize
    }
  }())

  $(function () {
    eah.tweetShare.initialize()
  })
}(jQuery, window))
